import { gql } from 'react-apollo';

// Roman: this comment is moved from legacy
// "Surely there is a better way to handle this QuestionTag mess!" one might say. One might Google and discover:
// a) somehow graphql has changed as a technology and this is indeed possible
// or b) no. this is, in fact, how graphql treats nested relationships.

const generateSubTagsQuery = (depth) => {
  let currentDepth = depth - 1;
  return `tags {
      ... on QuestionTag {
        title
        value
        label
        description
        categories {
          label
          aliases
        }
        ${currentDepth > 0 ? generateSubTagsQuery(currentDepth) : ''}
      }
      ... on QuestionTagCategory {
        header
        hierarchy
        aliases
        ${currentDepth > 0 ? generateSubTagsQuery(currentDepth) : ''}
      }
  }`;
};

export const getAggregateResults = gql`
  query getAggregateResults($subjectId: Int, $assignmentId: Int!, $htmlId: String!, $hierarchy: String!, $educationPeriod: Int!) {
    aggregateAssignmentInfo(assignmentId: $assignmentId, subjectId: $subjectId, htmlId: $htmlId, hierarchy: $hierarchy, educationPeriod: $educationPeriod) {
      id
      sectionName
      name
      accNum
      responseAnalysisSignedRequest
      scoringRubricRequest
      assignmentsResults {
        lastScoreByItem
        lastScoreByTag
        scoringRubricResults
        responseAnalysis
        sessionTemplate
        scoringSessionTemplate
        questions {
          ... on MultipleChoiceQuestion {
            id: itemId
            title
            isSecure
            isRetired
            learnosityItemReference
            type: __typename
          }
          ... on FreeResponseQuestion {
            id: itemId
            title
            isSecure
            isRetired
            learnosityItemReference
            children: scoringRubric {
              id
              title
              learnosityItemReference
              type: __typename
            }
            type: __typename
          }
        }
        assignmentMetadata {
          id,
          name,
          accNum,
          questionTagsById {
            ... on QuestionInfo {
              id,
              title,
              accNum,
              interactionType,
              questionType,
              tags {
                ... on QuestionTagCategory {
                  header
                  hierarchy
                  aliases
                  ${generateSubTagsQuery(3)}
                }
              }
            }
          }
        }
      }
    }
  }
`;
